(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$rootScope','$state', '$window', 'ProfileService'];

    function LoginService ($rootScope, $state, $window, ProfileService) {
        var v2AuthBaseUrl = '';

        ProfileService.getProfileInfo().then(function(response) {
            v2AuthBaseUrl = response.v2AuthBaseUrl || '';
        });

        var service = {
            open: open
        };

        return service;

        function open () {
            if($rootScope.fromState.name !== 'login') {
                $window.location.href = v2AuthBaseUrl + '/v2/auth/login';
            }
        }
    }
})();
